class DriplorePaymentOptions extends HTMLElement {
  observer = new MutationObserver(() => this.updateCheckout());
  pendingSelection = false;

  connectedCallback() {
    this.form = this.closest('form');
    this.details = this.closest('.product-details');
    this.details.addEventListener('variant:selected', this.variantSelected);
    this.details.addEventListener('variant:update', this.variantUpdated);
    this.addEventListener('click', this.checkout);
    this.observer.observe(this, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-disabled'],
    });
    this.updateCheckout();
  }

  disconnectedCallback() {
    this.observer.disconnect();
    this.details.removeEventListener('variant:selected', this.variantSelected);
    this.details.removeEventListener('variant:update', this.variantUpdated);
    this.removeEventListener('click', this.checkout);
  }

  variantSelected = () => {
    this.pendingSelection = true;
    this.updateCheckout();
  };

  variantUpdated = (event) => {
    if (event.detail.data.productId !== this.closest('product-form-component').dataset.productId) return;
    queueMicrotask(() => {
      if (!this.isConnected) return;
      this.pendingSelection = false;
      this.updateCheckout();
    });
  };

  updateCheckout() {
    const link = this.querySelector('a.shopify-payment-button__more-options');
    const button = this.querySelector('[data-card-checkout]');
    const note = this.querySelector('[data-payment-note]');
    if (!button || !note) return;
    button.hidden = !link;
    button.disabled = this.pendingSelection || !link || link.getAttribute('aria-disabled') === 'true'
      || this.form.querySelector('[name="id"]').disabled
      || this.form.querySelector('[ref="addToCartButton"]').disabled;
    note.hidden = !link && !this.querySelector('.shopify-payment-button__button--unbranded');
    this.toggleAttribute('data-checkout-ready', Boolean(link));
    this.toggleAttribute('data-selection-pending', this.pendingSelection);
  }

  checkout = (event) => {
    const button = event.target.closest('[data-card-checkout]');
    if (!button || button.disabled || this.pendingSelection) return;
    this.updateCheckout();
    if (button.disabled || !this.form.reportValidity()) return;
    this.querySelector('a.shopify-payment-button__more-options')?.click();
  };
}

if (!customElements.get('driplore-payment-options')) {
  customElements.define('driplore-payment-options', DriplorePaymentOptions);
}
